<div class="container-fluid">
    <mat-card style="margin-bottom: 15px">
        <div class="rounded border p-10">
            <div class="filters">
                <mat-form-field appearance="fill" class="date-range">
                    <mat-label>{{ "CASHIERMANAGEMENT.opening_interval" | translate }}</mat-label>
                    <mat-date-range-input [formGroup]="range" [rangePicker]="pickerRangeDate">
                        <input
                            matStartDate
                            [placeholder]="'CASHIERMANAGEMENT.start' | translate"
                            formControlName="dateOpen"
                        />
                        <input
                            matEndDate
                            [placeholder]="'CASHIERMANAGEMENT.final' | translate"
                            formControlName="dateClose"
                        />
                    </mat-date-range-input>
                    <mat-datepicker-toggle matSuffix [for]="pickerRangeDate"></mat-datepicker-toggle>
                    <mat-date-range-picker #pickerRangeDate [disabled]="_loaderService.isLoading | async"
                        ><mat-date-range-picker-actions>
                            <button mat-button matDateRangePickerCancel>
                                {{ "CASHIERMANAGEMENT.cancel" | translate }}
                            </button>
                            <button
                                mat-raised-button
                                color="primary"
                                matDateRangePickerApply
                                (click)="onRangeDateApply()"
                            >
                                {{ "CASHIERMANAGEMENT.apply" | translate }}
                            </button>
                        </mat-date-range-picker-actions></mat-date-range-picker
                    >
                </mat-form-field>

                <mat-form-field appearance="fill" [floatLabel]="'auto'">
                    <mat-label>{{ "CASHIERMANAGEMENT.user" | translate }}</mat-label>
                    <input
                        matInput
                        placeholder="Ex. joao.silva"
                        [(ngModel)]="cashierManagemenrParams.userName"
                        [disabled]="_loaderService.isLoading | async"
                    />
                </mat-form-field>

                <mat-form-field appearance="fill" [floatLabel]="'auto'">
                    <mat-label>{{ "CASHIERMANAGEMENT.entity" | translate }}</mat-label>
                    <input
                        matInput
                        [(ngModel)]="cashierManagemenrParams.entityDescription"
                        [disabled]="_loaderService.isLoading | async"
                    />
                </mat-form-field>

                <mat-form-field appearance="fill" [floatLabel]="'auto'">
                    <mat-label>{{ "CASHIERMANAGEMENT.statusCashier" | translate }}</mat-label>
                    <mat-select
                        [disabled]="_loaderService.isLoading | async"
                        [(value)]="cashierManagemenrParams.cashierManagementStatus"
                    >
                        <mat-option
                            *ngFor="let status of cashierManagementStatusEnumArray"
                            [value]="cashierManagementStatusEnum[status]"
                        >
                            {{ "ENUM." + status | translate }}
                        </mat-option>
                    </mat-select>
                </mat-form-field>

                <div class="buttonFilter">
                    <button
                        mat-raised-button
                        color="accent"
                        (click)="onCleanFilter()"
                        [disabled]="_loaderService.isLoading | async"
                    >
                        <mat-icon>clear</mat-icon>{{ "CASHIERMANAGEMENT.clear" | translate }}
                    </button>
                </div>
                <div class="buttonFilter">
                    <button
                        mat-raised-button
                        color="primary"
                        (click)="onSearch()"
                        [disabled]="_loaderService.isLoading | async"
                    >
                        <mat-icon>search</mat-icon> {{ "CASHIERMANAGEMENT.filter" | translate }}
                    </button>
                </div>
                <div class="buttonFilter">
                    <button
                        mat-raised-button
                        color="accent"
                        (click)="onExportData()"
                        [disabled]="_loaderService.isLoading | async"
                    >
                        <mat-icon>file_download</mat-icon> {{ "CASHIERMANAGEMENT.export" | translate }}
                    </button>
                </div>
            </div>
        </div>

        <div *ngIf="resOk && lines.length > 0" style="margin-top: 15px">
            <simple-list id="chashierTable" [data]="lines" [config]="simpleTableConfig" (reloadTable)="onReloadTable($event)">
            </simple-list>
        </div>

        <div *ngIf="resOk && lines.length == 0">
            <mat-card class="p-10" style="margin-top: 15px">
                <p class="notData">{{ "CASHIERMANAGEMENT.thereIsNoDataToLoad" | translate }}</p>
            </mat-card>
        </div>

        <loader></loader>
    </mat-card>
</div>
